import { Injectable } from '@angular/core';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IResourceItem } from '@common/interfaces/resourceItem';
import { ResourceItemStore } from './resourceItem.store';
import { ResourceItemQuery } from './resourceItem.query';

@Injectable({
  providedIn: 'root'
})
export class ResourceItemService extends CrudService<IResourceItem, ResourceItemStore, ResourceItemQuery> {

  constructor(
    protected store: ResourceItemStore,
    public query: ResourceItemQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
  ) {
    super(
      Topics.RESOURCE_ITEMS,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
